export const state = () => ({
  routerArguments: null,
})

export const mutations = {
  setRouterArguments(state,v) {
    state.routerArguments = v
  }
}


export default {
	namespaced: true,
	state,
	mutations
}
